import styled from "styled-components";

export const MenuIconContainer = styled.div`
  display: block;
  position: fixed;
  top:0;
  left:0;
  margin-top: 18px;  
  color: white;
  z-index: 1000;

  @media (min-width: 1000px) {
    display: none;
  }
`;

export const SidebarContainer = styled.div`
  display: block;
  z-index: 1000;
  position: fixed;
  color: white;
  background-color: var(--slack-color);
  width: 50%;
  height: calc(100vh - 60px);
  border-top: 1px solid #49274b;
  max-width: 260px;
  margin-top: 60px;
  margin-bottom: 100px;
  top: 0;
  min-height: 0 !important;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-track {
    background: lightgray;
    border-radius: 5px;
    border-right: 1px solid var(--slack-color);
  }

  ::-webkit-scrollbar-thumb {
    background: #999999;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #7a1d7c;
  }

  > hr {
    margin: 10px 0;
    border: 1px solid #49274b;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #49274b;
  padding: 13px;

  > svg {
    background-color: white;
    color: #49274b;
    padding: 8px;
    font-size: 18px;
    border-radius: 999px;
  }
`;

export const SidebarInfo = styled.div`
  flex: 1;
  > h2 {
    font-size: 15px;
    font-weight: 900;
    margin-bottom: 5px;
  }

  > h3 {
    display: flex;
    font-size: 13px;
    font-weight: 400;
    align-items: center;
  }

  > h3 > svg {
    font-size: 14px;
    margin-top: 1px;
    margin-right: 2px;
    color: green;
  }
`;
